import React, { useState } from 'react'
import Button from '@components/Button'
import { ScormButtonWrapper, StartCard, ScormContentWrapper, ScormDescription, StartLink, ScormTitle } from './style'
import { getUnitContent, openInNewTab } from './helpers'
import { FormattedMessage } from 'react-intl'
import CardInfoModal from './CardInfoModal'

const Start = ({ unit }: { unit: any }) => {
  const { title, description, startUrl } = getUnitContent(unit)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const isDisabled = !startUrl

  return (
    <StartCard>
      <ScormContentWrapper>
        <ScormTitle>{title}</ScormTitle>
        <ScormDescription>{description}</ScormDescription>

        <StartLink onClick={() => setIsModalOpen(true)} style={{ cursor: 'pointer' }}>
          <FormattedMessage id="What is an e-learning module?" defaultMessage={'What is an e-learning module?'} />
        </StartLink>

        <ScormButtonWrapper>
          <Button color="brandPrimary" fullWidth onClick={() => openInNewTab(startUrl)} disabled={isDisabled}>
            <FormattedMessage id="Start" />
          </Button>
        </ScormButtonWrapper>
      </ScormContentWrapper>

      <CardInfoModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </StartCard>
  )
}

export default Start
